import React from 'react';
import {connect} from 'react-redux';
import {countDiscountPrice, countDiscountPriceWithoutRound, print} from '../../../common/lib/util';
import {Map} from "immutable";

class PrintTest extends React.Component {

  static propTypes = {
      msg: React.PropTypes.object,
    printType: React.PropTypes.string,
    printAddress: React.PropTypes.string,
    organization: React.PropTypes.object,
    branch: React.PropTypes.object,
    deviceId: React.PropTypes.number,
    printLength: React.PropTypes.number,
    bar: React.PropTypes.object,
    selectedCashbox: React.PropTypes.object
  };

  constructor(props) {
    super(props);

    this.testPrint = this.testPrint.bind(this);
  }

  testPrint() {
    const {printType, printAddress, organization, branch, bar, selectedCashbox, deviceId, printLength} = this.props;

    let items = Map();
    items = items.set('1', Map({'price': 42, 'discount': 0, 'pcs': 7, 'name': 'Testovací produkt 1'}));
    items = items.set('2', Map({'price': 77, 'discount': 0, 'pcs': 9, 'name': 'Testovací 2'}));
    items = items.set('3', Map({'price': 22, 'discount': 0, 'pcs': 1, 'name': 'produkt 3'}));

    let printArray = [];

    const discount = 0;
    const totalPricePreRound = 141;
    const totalPriceRound = Math.round(totalPricePreRound);
    const discountPrice = countDiscountPrice(totalPriceRound, discount);

    printArray.push(['title', branch.get('name'), 'ct']);

    let cashboxName = selectedCashbox.get('name');
    printArray.push(['text', `${organization.get('name')}, ${bar.get('name')}${!!cashboxName ? ', ' + cashboxName : ''}`, 'ct']);
    printArray.push(['text', `IČO ${organization.get('regnr')}, DIČ ${organization.get('vatId')}`, 'ct']);
    printArray.push(['text', organization.getIn(['address', 'name']), 'ct']);

    printArray.push(['-']);
    items.forEach(item => {
      let itemName = `${item.get('name')} (${(item.get('price')).toFixed(2)})`;
      let thirdColumn = '';
      if (typeof item.get('pcs') !== 'undefined') {
        thirdColumn = `${countDiscountPriceWithoutRound((item.get('price') * item.get('pcs')), item.get('discount')).toFixed(2)}`;
      }
      printArray.push([`${item.get('pcs')}x`, itemName, thirdColumn]);
    });
    printArray.push(['-']);

    printArray.push(['title', `CZK ${Math.round(discountPrice).toFixed(2)}`, 'rt']);

    if (!organization.get('vatPayer')) {
      printArray.push(['text', 'Neplátce DPH', 'ct']);
    }

    printArray.push([`Doklad č. ${deviceId}-98764`]);

    let paymentText = selectedCashbox.get('cashbox') === 'CASH' ? 'Platba v hotovosti' : 'Platba platební kartou';
    printArray.push([paymentText]);

    printArray.push([]);
    printArray.push(['text', 'DĚKUJEME A PŘIJĎTE ZAS', 'ct']);
    printArray.push(['text', 'prodalo a vytisklo Trisbee.com', 'ct']);

    print(printType, printAddress, printArray, false, printLength, false, null);
  }

  render() {
    const {printType, msg} = this.props;

    return (
      <div className="table-row">
        <div className="table-cell" style={{width: '55.55%'}}>
          <div className="boxBtn text-left text-black">
          </div>
        </div>
        <div className="table-cell" style={{width: '22.22%'}}>
          <div className="boxBtn text-black text-l"></div>
        </div>
        <div className="table-cell" style={{width: '22.22%'}}>
          <div
            className={`boxBtn color-green text-l ${['escpos-usb', 'escpos-serial', 'escpos-net'].indexOf(printType) > -1 ? '' : 'disabled'}`}>
            <div className="boxBtn-inner" onClick={this.testPrint}>
              <span>
                  {msg.settings.print.test}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
  printType: state.device.printType,
  printLength: state.device.printLength,
  printAddress: state.device.printAddress,
  organization: state.categories.get('organization'),
  branch: state.branches.get('branch'),
  bar: state.bars.get('bar'),
  selectedCashbox: state.cashboxes.get('selectedCashbox'),
  deviceId: state.device.get('id')
}))(PrintTest);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/PrintTest.js